export const SIDEBAR_MUTED_TEXT = "text-slate-500 dark:text-slate-400";
export const SIDEBAR_TEXT_INACTIVE = "text-brand-sidebar-text dark:text-slate-300";
export const SIDEBAR_ICON_ACTIVE = "text-blue-700 dark:text-blue-300";
export const SIDEBAR_ICON_INACTIVE = SIDEBAR_TEXT_INACTIVE;
export const SIDEBAR_ITEM_BASE = "group relative flex items-center rounded-lg";
export const SIDEBAR_ITEM_COLLAPSED = "px-2 py-2 justify-center";
export const SIDEBAR_ITEM_EXPANDED = "px-3 py-2 gap-3";
export const SIDEBAR_ITEM_ACTIVE =
  "bg-brand-sidebar-active text-brand-sidebar-text dark:bg-slate-800/60 dark:text-white";
export const SIDEBAR_HOVER_BG = "hover:bg-brand-sidebar-hover dark:hover:bg-slate-800";
